/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_Permission_Name_Templatesskills_ModifyInputs */

const en_enum_permission_name_templatesskills_modify = /** @type {(inputs: Enum_Permission_Name_Templatesskills_ModifyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Templatesskills Modify`)
};

const de_enum_permission_name_templatesskills_modify = /** @type {(inputs: Enum_Permission_Name_Templatesskills_ModifyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Templatesskills Modify`)
};

/**
* | output |
* | --- |
* | "Templatesskills Modify" |
*
* @param {Enum_Permission_Name_Templatesskills_ModifyInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const enum_permission_name_templatesskills_modify = /** @type {((inputs?: Enum_Permission_Name_Templatesskills_ModifyInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_Permission_Name_Templatesskills_ModifyInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_permission_name_templatesskills_modify(inputs)
	return de_enum_permission_name_templatesskills_modify(inputs)
});